<template>
    <FancyDialog v-bind="{ ...$attrs }" v-on="$listeners">
        <v-container fluid class="dialog_container">
            <img
                width="90"
                height="90"
                class="mb-1"
                src="@/assets/images/imgWarning.svg"
                alt=""
            />
            <p class="title mb-3">
                您上期集點卡還剩{{ point }}點尚未兌換，是否 要優先兌換上期點數?
            </p>
            <div class="footer d-flex justify-center">
                <FancyButton
                    isGrey
                    class="btn mr-3"
                    label="兌換上期"
                    @click="$router.push(previous_link)"
                />
                <FancyButton
                    isRed
                    class="btn"
                    label="兌換本期"
                    @click="$router.push(now_link)"
                />
            </div>
        </v-container>
    </FancyDialog>
</template>

<script>
import FancyDialog from '@/components/FancyDialog.vue';
import FancyButton from '@/components/FancyButton.vue';
export default {
    components: {
        FancyDialog,
        FancyButton,
    },
    name: 'PopupCardExchange',
    props: {
        point: {
            type: Number,
        },
        previous_link: {
            type: String,
        },
        now_link: {
            type: String,
        },
    },
    emits: ['input', 'click:confirm'],
    data: () => ({}),
};
</script>

<style lang="scss" scoped>
div.dialog_container {
    p.title {
        color: $color_main_first;
        font-size: 20px;
        line-height: 23px;
        text-align: center;
        letter-spacing: -0.3px;
    }
    p.desc {
        font-size: 14px;
        line-height: 24px;
        color: $color_main_black;
    }
    > .footer {
        .btn {
            height: 50px;
            width: 100%;
            @media screen and (max-width: 374px) {
                max-width: 118px;
            }
            @media screen and (min-width: 375px) {
                max-width: 145.5px;
            }
        }
    }
}
</style>
